import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media',
  template: require('./social-media.component.html'),
  styles: [require('./social-media.component.css')]
})
export class SocialMediaComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
  
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/social-media/social-media.component.ts